import { configureStore } from "@reduxjs/toolkit";
import usersReducer from "../slices/users/usersSlices";
import categoryReducer from "../slices/category/categorySlices";
import postReducer from "../slices/posts/postSlices";
const store = configureStore({
  reducer: {
    users: usersReducer,
    category: categoryReducer,
    posts: postReducer,
  },
});

export default store;
